import React from "react";
import PropTypes from "prop-types";
import PrimaryLink from "../../elements/primary-link";
import "./style.scss";
import CustomRow from "./components/custom-row";
import { generateReactKey } from "../../utils/reactKey";

const AllReceiptsTable = ({ receipts, dateLabel, amountLabel, receiptsNumberLabel, invoiceLabel, receiptLabel, receiptLinkLabel, invoiceLinkLabel, linkCallback, numberOfItemToshow }) => {
  return (
    <>
      <div className="all-receipts-table-mobile">
        {receipts.map((receipt, index) => {
          return (
            <div className="table-row" key={`${receipt.receiptNumber}${index}`}>
              <CustomRow header={dateLabel} value={receipt.date} />
              <CustomRow header={amountLabel} value={receipt.amount} />
              <CustomRow header={receiptsNumberLabel} value={receipt.receiptNumber} />
              <div className="sub-row">
                <div className="row-column -link">
                  <PrimaryLink callback={() => linkCallback("invoice", receipt)} buttonText={invoiceLinkLabel} colorScheme={"primary"} />
                </div>
                <div className="row-column -link -last">
                  <PrimaryLink callback={() => linkCallback("receipt", receipt)} buttonText={receiptLinkLabel} colorScheme={"primary"} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="all-receipts-table">
        <div className="table-header">
          <div className="header-date-cell" key={1}>
            {dateLabel}
          </div>
          <div className="header-date-cell" key={2}>
            {amountLabel}
          </div>
          <div className="header-date-cell" key={3}>
            {receiptsNumberLabel}
          </div>
          <div className="header-date-cell" key={4} />
          <div className="header-date-cell" key={5} />
        </div>
        <div className="table-body">
          {receipts.map((receipt, index) => {
            return (
              <div className="table-row" key={index}>
                <div className="date-cell">{receipt.date}</div>
                <div className="amount-cell">{receipt.amount}</div>
                <div className="number-cell">{receipt.receiptNumber}</div>

                <div className="link-cell">
                  <PrimaryLink callback={() => linkCallback("receipt", receipt)} buttonText={receiptLinkLabel} colorScheme={"primary"} />
                </div>
                <div className="link-cell">
                  <PrimaryLink callback={() => linkCallback("invoice", receipt)} buttonText={invoiceLinkLabel} colorScheme={"primary"} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
AllReceiptsTable.propTypes = {
  receipts: PropTypes.array,
  dateLabel: PropTypes.string
};
export default AllReceiptsTable;
